import React, { useState } from 'react';
import { ChevronRight, ChevronLeft, MapPin } from 'lucide-react';

export default function MapSidebar({ opportunities = [], mapBounds, onItemClick }) {
  const [collapsed, setCollapsed] = useState(false);

  const located = opportunities.filter((opp) => opp.location?.coordinates?.length === 2);
  const visible = mapBounds
    ? located.filter((opp) => {
        const [lng, lat] = opp.location.coordinates;
        return mapBounds.contains({ lat, lng });
      })
    : located;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        height: '100%',
        flexShrink: 0,
      }}
    >
      {/* Toggle button */}
      <button
        onClick={() => setCollapsed((c) => !c)}
        style={{
          alignSelf: 'center',
          backgroundColor: '#0A0F1A',
          border: '1px solid #1a1f2e',
          borderRight: 'none',
          borderRadius: '6px 0 0 6px',
          padding: '8px 4px',
          cursor: 'pointer',
          color: '#00CEC9',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
        }}
        title={collapsed ? 'Mostrar lista de locales' : 'Colapsar lista'}
      >
        {collapsed ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
      </button>

      {/* Panel */}
      <div
        style={{
          width: collapsed ? '56px' : '240px',
          backgroundColor: 'rgba(5,7,10,0.93)',
          borderLeft: '1px solid #1a1f2e',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden',
          transition: 'width 0.2s ease',
        }}
      >
        {/* Header — always visible */}
        <div
          onClick={() => setCollapsed((c) => !c)}
          style={{
            padding: collapsed ? '12px 0' : '12px 14px',
            borderBottom: '1px solid #1a1f2e',
            display: 'flex',
            justifyContent: collapsed ? 'center' : 'space-between',
            alignItems: 'center',
            flexShrink: 0,
            cursor: 'pointer',
            userSelect: 'none',
          }}
        >
          {collapsed ? (
            /* Collapsed: just the count, vertical label below */
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#00CEC9',
                  fontFamily: "'Orbitron', sans-serif",
                }}
              >
                {visible.length}
              </span>
              <span
                style={{
                  fontSize: '7px',
                  letterSpacing: '1px',
                  color: '#636e72',
                  fontFamily: "'Orbitron', sans-serif",
                  writingMode: 'vertical-rl',
                  textOrientation: 'mixed',
                  transform: 'rotate(180deg)',
                }}
              >
                LOCALES
              </span>
            </div>
          ) : (
            /* Expanded: label + count */
            <>
              <span
                style={{
                  fontSize: '10px',
                  letterSpacing: '2px',
                  color: '#636e72',
                  fontFamily: "'Orbitron', sans-serif",
                }}
              >
                LOCALES VISIBLES
              </span>
              <span
                style={{
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#00CEC9',
                  fontFamily: "'Orbitron', sans-serif",
                }}
              >
                {visible.length}
              </span>
            </>
          )}
        </div>

        {/* List — only when expanded */}
        {!collapsed && (
          <div style={{ flex: 1, overflowY: 'auto', padding: '6px 0' }}>
            {visible.length === 0 ? (
              <p
                style={{
                  fontSize: '11px',
                  color: '#636e72',
                  textAlign: 'center',
                  padding: '20px 14px',
                  fontFamily: 'sans-serif',
                }}
              >
                No hay locales en el área visible.
              </p>
            ) : (
              visible.map((opp) => (
                <div
                  key={opp._id}
                  onClick={() => onItemClick && onItemClick(opp)}
                  style={{
                    padding: '8px 14px',
                    cursor: 'pointer',
                    borderBottom: '1px solid rgba(26,31,46,0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    transition: 'background 0.15s',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(0,206,201,0.06)')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  <MapPin size={12} color={opp.visuals?.color || '#0B3D91'} style={{ flexShrink: 0 }} />
                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: '11px',
                        color: 'white',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontFamily: 'sans-serif',
                      }}
                    >
                      {opp.name}
                    </div>
                    <div
                      style={{
                        fontSize: '9px',
                        color: '#636e72',
                        letterSpacing: '0.5px',
                        fontFamily: "'Orbitron', sans-serif",
                      }}
                    >
                      {opp.brand || '—'}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}
